import { render } from "./page_05.vue?vue&type=template&id=3802aba2"
import script from "./page_05.vue?vue&type=script&lang=js"
export * from "./page_05.vue?vue&type=script&lang=js"
script.render = render

export default script